import { useExtensionRequest } from "../../apis/extension/useExtensionRequest"

export const useExternalHandlers = () => {
    const { storeTabId } = useExtensionRequest()

    const LIDomain = 'https://www.linkedin.com'
    const LIPagePrefix = 'https://www.linkedin.com/in/'

    const navigateExternalAndFocus = (link: string, newTab = true) => {
        window.open(link, !newTab ? '_self' : '_blank')?.focus();
    }

    const navigateExternal = (link: string, newTab = true) => {
        window.open(link, !newTab ? '_self' : '_blank');
    }

    const visitLIProfile = (publicIdentifier: string) => {
        navigateExternal(`${LIPagePrefix}${publicIdentifier}`)
    }

    const visitConnectionHandler = (publicIdentifier: string) => {
        storeTabId('storeAppTabId')
        visitLIProfile(publicIdentifier)
    }

    const visitChromeStore = () => {
        navigateExternalAndFocus('https://chromewebstore.google.com/detail/crm-phone-number-email-fi/pglgkbbnncfddpclbgomegdnjihljkdp?hl=en')
    }

    const visitChromeBrowserDownload = () => {
        navigateExternalAndFocus('https://www.google.com/chrome/')
    }

    const openHelpDesk = () => {
        navigateExternal('https://help.leaddelta.com/en/')
    }

    const openOnboarding = () => {
        navigateExternal('https://help.leaddelta.com/en/article/onboarding-leaddelta-manual-1ah5tl2/')
    }

    const openAbout = () => {
        navigateExternal('https://leaddelta.com/about/')
    }

    const openRoadmap = () => {
        navigateExternal('https://roadmap.leaddelta.com/')
    }

    const chatWithUs = () => {
        navigateExternal('https://help.leaddelta.com/en/')
    }

    const openCSVImportStart = () => {
        navigateExternal("https://help.leaddelta.com/en/article/csv-import-130ngwd/")
    }

    const openCSVRequirements = () => {
        navigateExternal("https://help.leaddelta.com/en/article/what-is-the-right-format-for-the-csv-file-import-1dc2aax/")
    }

    const openPermissionHandler = () => {
        navigateExternal(`https://help.leaddelta.com/en/article/give-permission-to-leaddelta-to-sync-your-linkedin-connections-13d9ydl/`)
    }

    const openDemoProduct = () => {
        navigateExternal(`https://meetings.hubspot.com/ved/enterprise`)
    }

    const openTermsAndConditions = () => {
        navigateExternal(`https://leaddelta.com/terms`)
    }

    const openPrivacyPolicy = () => {
        navigateExternal(`https://leaddelta.com/privacy`)
    }

    const openPricing = () => {
        navigateExternal(`https://leaddelta.com/pricing`)
    }
    
    const openSyncMessage = () => {
        navigateExternal(`https://help.leaddelta.com/en/article/maximizing-the-power-of-tags-oa8b7j/`)
    }

    const updateLeadDeltaExtension = () => {
        navigateExternal(`https://help.leaddelta.com/en/article/how-to-ensure-you-have-the-latest-version-of-leaddelta-chrome-app-updates-autoupdating-1d592fu/`)
    }

    const openLinkedinWebsite = () => {
        navigateExternal(`https://linkedin.com/`)
    }

    const openCSVEnrichmentUpload = () => {
        navigateExternal("https://help.leaddelta.com/en/article/data-enrichment-csv-upload-1atuyt3/")
    }

    const openCSVEnrichmentRequirements = () => {
        navigateExternal(`https://help.leaddelta.com/en/article/csv-enrichment-what-is-the-right-format-for-the-csv-file-enrichment-q6fnw1/?bust=1747288237059`)
    }

    const openCSVEnrichmentSample = () => {
        navigateExternal(`https://docs.google.com/spreadsheets/d/1ueKFo7RiKVdnNuhYCJG4SUvriXA_thNZ0GLOGmlO1mA/edit?gid=0#gid=0`)
    }

    const learnMoreAboutCredits = () => {
        navigateExternal(`https://help.leaddelta.com/en/article/work-in-progress-rollover-credits-1acyy2j/?bust=1752213353619`)
    }

    const scheduleMeeting = () => {
        navigateExternal(`https://try.leaddelta.com/meetings/ved/welcome`)
    }

    const openEnterpriseMeeting = () => {
        navigateExternal(`https://try.leaddelta.com/meetings/ved/enterprise`)
    }

    const openDoneForYouMeeting = () => {
        navigateExternal(`https://try.leaddelta.com/meetings/ved/dfy`)
    }

    return {
        LIPagePrefix,
        visitLIProfile,
        visitConnectionHandler,
        visitChromeStore,
        visitChromeBrowserDownload,
        openHelpDesk, 
        openOnboarding, 
        openAbout,
        openRoadmap,
        chatWithUs,
        openCSVImportStart,
        openCSVRequirements,
        openPermissionHandler,
        openDemoProduct,
        openTermsAndConditions,
        openPrivacyPolicy,
        openPricing,
        openSyncMessage,
        updateLeadDeltaExtension,
        openLinkedinWebsite,
        openCSVEnrichmentUpload,
        openCSVEnrichmentRequirements,
        openCSVEnrichmentSample,
        learnMoreAboutCredits,
        scheduleMeeting,
        openEnterpriseMeeting,
        openDoneForYouMeeting
    }
}